export var DrawerTabs;
(function (DrawerTabs) {
    DrawerTabs["Pages"] = "Pages";
    DrawerTabs["MyAccount"] = "MyAccount";
})(DrawerTabs || (DrawerTabs = {}));
//# sourceMappingURL=drawer.js.map